/* eslint-disable */
export default class UploadAdapter {
  constructor (loader) {
    this.loader = loader
  }

  getLoader () {
    return this.loader
  }

  upload () {
    return this.loader.file.then(file => new Promise((resolve, reject) => {
      this._initRequest()
      this._initListeners()
      this._sendRequest(resolve, reject, file)
    }))
  }

  /**
   * 원래 request 생성 함수
   * 현재는 request 하지 않고 이미지를 Base64로 인코딩하여 주소로 사용
   */
  _initRequest () {
    // const xhr = this.xhr = new XMLHttpRequest()
    // xhr.open('POST', 'http://172.30.1.14:8889/image/', true)
    // xhr.responseType = 'json'
  }
  /**
   * 이미지 파일을 Base64로 인코딩
   * @param {file} image 이미지 파일을 받음
   * @returns {Object} Promise 객체를 반환
   */

  encodeBase64ImageFile (image) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      // convert the file to base64 text
      reader.readAsDataURL(image)
      // on reader load somthing...
      reader.onload = (event) => {
        resolve(event.target.result)
      }
      reader.onerror = (error) => {
        reject(error)
      }
    })
  }

  /**
   * 원래는 서버에 이미지를 업로드하고 주소를 받아오는 함수
   * 현재는 base64 인코딩 방식 사용으로 인해 사용하지 않음
  _initListeners (resolve, reject, file) {
    // const xhr = this.xhr
    // const genericErrorText = '파일을 업로드 할 수 없습니다.'

    // xhr.addEventListener('error', () => { reject(genericErrorText) })
    // xhr.addEventListener('abort', () => reject())
    // xhr.addEventListener('load', () => {
    //   const response = xhr.response
    //   if (!response || response.error) {
    //     return reject(response && response.error ? response.error.message : genericErrorText)
    //   }

    //   resolve({
    //     default: response.url // 업로드된 파일 주소
    //   })
    // })
  } */

  /**
   * 이미지를 base64로 인코딩 하고 해당 주소를 resolve로 반환
   * @param {*} resolve promise 객체로 전달
   * @param {*} reject promise 객체로 전달
   * @param {file} file 이미지 파일
   * @returns {undefined} 아무것도 반환하지 않음
   */

  _sendRequest (resolve, reject, file) {
    // const data = new FormData()
    // data.append('image', file)
    // this.xhr.send(data)
    // store.commit('home/addFiles', file)
    this.encodeBase64ImageFile(file)
      .then((data) => {
        resolve({
          default: data
        })
      }).catch(err => {
        reject('파일을 업로드 할 수 없습니다.', err)
      })
  }
}
export const uploader = function (editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) =>
    new UploadAdapter(loader)
}
